import useClockInOut from './useClockInOut'

const useClockIn = (revisionId: string) => {
  const { clockInOut, ...others } = useClockInOut({ type: 'in', revisionId })

  return {
    ...others,
    clockIn: clockInOut,
  }
}

export default useClockIn
